module.exports = __webpack_public_path__ + "static/media/fashion-4.68131fd3.jpg";